import {Alert} from '@mui/material';
import {ExamModule} from '@cp/model';
import MarkdownContentRenderer from '../../atoms/MarkdownContentRenderer/MarkdownContentRenderer';
import {env} from '../../config/env';
import {Maybe} from '@coolcolduk/typescript-util';

export interface BondTextAttributionProps {
  examModule?: Maybe<ExamModule>;
}

export default function BondTextAttribution({examModule}: BondTextAttributionProps) {
  // Build attribution: use existing attribution if available, otherwise build from author, source, license
  let attribution = examModule?.attribution;

  if (!attribution) {
    const subjectLabel = examModule?.subject ? env.subjects[examModule.subject]?.label : null;

    // Build attribution in format: "A [title] [subject] lesson by [author] licensed under [license]"
    if (examModule?.author && examModule?.license) {
      const parts: string[] = ['A'];

      if (examModule?.name) {
        parts.push(examModule.name);
      }

      if (subjectLabel) {
        parts.push(subjectLabel);
      }

      parts.push('lesson', 'by', examModule?.author, 'licensed under', examModule?.license);

      attribution = parts.join(' ');
    }
  }

  if (!attribution) {
    return null;
  }

  return (
    <Alert severity="info" sx={{mt: 1}} data-testid="bond-text-attribution">
      <MarkdownContentRenderer content={attribution} />
    </Alert>
  );
}
